export default "__VITE_ASSET__BrHqBIHm__"